function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cookieIcon_svg__cls-1,.cookieIcon_svg__cls-2,.cookieIcon_svg__cls-3{fill:none}.cookieIcon_svg__cls-1,.cookieIcon_svg__cls-2{stroke:#fff;stroke-width:17px}.cookieIcon_svg__cls-1{stroke-linecap:round;stroke-linejoin:round}.cookieIcon_svg__cls-2{stroke-miterlimit:10}.cookieIcon_svg__cls-3{stroke:#000;stroke-width:0}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "cookieIcon_svg__cls-1",
  cx: 202.21,
  cy: 194.56,
  r: 160
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cookieIcon_svg__cls-1",
  d: "M152.21 84.56c15.06-6.81 32.4-10 50-10M82.21 194.56a120.52 120.52 0 0130-80"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cookieIcon_svg__cls-2",
  cx: 272.21,
  cy: 234.56,
  r: 10
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "cookieIcon_svg__cls-2",
  cx: 202.21,
  cy: 284.56,
  r: 10
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "cookieIcon_svg__cls-2",
  cx: 192.21,
  cy: 154.56,
  r: 18.52
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "cookieIcon_svg__cls-2",
  cx: 142.21,
  cy: 224.56,
  r: 10
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cookieIcon_svg__cls-2",
  cx: 282.21,
  cy: 154.56,
  r: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cookieIcon_svg__cls-3",
  d: "M38.71-22.94v36M-15.29 31.06h36M-15.29 358.06h36M38.71 412.06v-36M365.71-22.94v36M419.71 31.06h-36M419.71 358.06h-36M365.71 412.06v-36"
});

function SvgCookieIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cookieIcon_svg__\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1",
    viewBox: "0 0 404.43 389.13"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default SvgCookieIcon;